import BaoDialogViewModel from "../../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import * as moment from "moment";

/** 
 * Dialog for choosing additional data to be sent to the StartAudit function
 */
class StartAuditDialog {
    constructor(dialog: BaoDialogViewModel) {
        this.Dialog = dialog;
    }
    Bao = Bao;
    StartDate = ko.observable(moment().format(Bao.Utils.DateTimeFormat));
    EndDate = ko.observable(moment().add(2, 'hours').format(Bao.Utils.DateTimeFormat));
    Dialog = null;

    /**
     * Gets the BaoDateTimeBox to select the audit start date
     */
    public DateTimeBoxAuditStartDate: Bindings.baoDateTimeBox = {
        mode: 'datetime',
        culture: Bao.Session.Language.Symbol,
        value: this.StartDate
    };

    /**
     * Gets the BaoDateTimeBox to select the audit end date
     */
    public DateTimeBoxAuditEndDate: Bindings.baoDateTimeBox = {
        mode: 'datetime',
        culture: Bao.Session.Language.Symbol,
        value: this.EndDate,
        minDate: this.StartDate
    };

    /**
     * Gets the BaoDateTimePicker-instance for audit start date.
     */
    public DateTimePickerAuditStartDate: Bindings.baoDateTimePicker = {
        mode: 'datetime'
    };

    /**
     * Gets the BaoDateTimePicker-instance for audit end date.
     */
    public DateTimePickerAuditEndDate: Bindings.baoDateTimePicker = {
        mode: 'datetime',
        minDate: this.StartDate
    };

    /**
     * Check data validity 
     */
    CompleteCheck() {
        if (Bao.Utils.String.IsNullOrWhitespace(ko.unwrap(this.StartDate)) ||
            Bao.Utils.String.IsNullOrWhitespace(ko.unwrap(this.EndDate))) {
            return false;
        }
        return true;
    }
}
export default StartAuditDialog;